import React from 'react';
import './src/styles/global.css';
import { AuthProvider } from './src/context/AuthContext';
import { ThemeProvider } from './src/context/ThemeContext';

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <ThemeProvider>{element}</ThemeProvider>
  </AuthProvider>
);

